import { isNullOrEmpty, Dictionary, cloneDeep } from '@awp/core/utils';
import { SirenResponse, SirenLink, SirenEntity, SirenAction, SirenProperty } from './model';


export function getLink(name: string, sirenResponse: SirenResponse): SirenLink | null {
  if (isNullOrEmpty(name)) {
    throw new Error('Link name is not defined');
  }
  if (sirenResponse == null || sirenResponse.links == null) {
    return null;
  }

  const result = sirenResponse.links.find(p => p.rel.includes(name));
  return result;
}

export function getEntity(name: string, sirenEntity: SirenEntity | SirenEntity[]): SirenEntity | null {
  if (isNullOrEmpty(name)) {
    throw new Error('Entity name is not defined');
  }

  if (sirenEntity == null) {
    return null;
  } else if (Array.isArray(sirenEntity)) {
    const result = sirenEntity.find(p => p.rel.includes(name));
    return result;
  } else if (sirenEntity.entities == null) {
    return null;
  } else {
    const result = sirenEntity.entities.find(p => p.rel.includes(name));
    return result;
  }
}

export function getEntities(name: string, sirenEntity: SirenEntity | SirenEntity[]): SirenEntity[] | null {
  if (isNullOrEmpty(name)) {
    throw new Error('Entity name is not defined');
  }

  if (sirenEntity == null) {
    return null;
  } else if (Array.isArray(sirenEntity)) {
    const result = sirenEntity.filter(p => p.rel.includes(name));
    return result;
  } else if (sirenEntity.entities == null) {
    return null;
  } else {
    const result = sirenEntity.entities.filter(p => p.rel.includes(name));
    return result;
  }
}

export function getEntityProperties(name: string, sirenEntity: SirenEntity | SirenEntity[]): SirenProperty | null {
  const entity = getEntity(name, sirenEntity);
  return entity == null ? null : entity.properties;
}


export function getAction(name: string, sirenResponse: SirenResponse | SirenEntity): SirenAction | null {
  if (isNullOrEmpty(name)) {
    throw new Error('Entity name is not defined');
  }
  if (sirenResponse == null || sirenResponse.actions == null) {
    return null;
  }

  const result = sirenResponse.actions.find(p => p.name === name);
  return result;
}

export function flattenSirenProperties(entity: SirenEntity): { [key: string]: any} {

  let properties = { ...entity.properties };

  if (entity.entities != null) {
    entity.entities.forEach(item => {
      if (item.class.length === 1) {
        properties[item.class[0]] = item.properties;
      } else if (item.class.includes('collection')) {
        const collection = flattenSirenProperties(item);

        if (collection != null) {
          properties = {
            ...properties,
            ...collection
          }
        }
      }
    });
  }

  return properties;
}


export function flattenSirenEntity(entity: SirenEntity): { [key: string]: any} {
  let entities = {};

  if (entity.entities != null) {
    entities = entity.entities.reduce((result, item) => {
      if (item.class.length === 1) {
        result[item.class[0]] = item.properties;
      }
      return result;
    }, {})
  }

  return {
    ...entity.properties,
    ...entities
  };
}

export function extractSirenEntities(entities: SirenEntity[], ...rels: string[]): Dictionary<any> {
  if (entities == null) {
    return null;
  }

  const items =  entities.filter(p => p.rel.some(r => rels.includes(r)))
    .reduce((result, item) => {
      const name = item.class.find(p => p != 'collection');
      result[name] = {
          id: item.entities[0].class[0],
          options: item.entities.map(p => cloneDeep(p.properties))
        };
      return result;
    }, {});

  return items;
}
